'use strict';
var searchPartMixin = require('../../modules/mixins/searchpart.mixin');

module.exports = Odigeo.Model.extend(searchPartMixin.extend({
    defaults: {
        dateStr: null,
        departure: null,
        destination: null,
    },

    initialize: function() {
        this.init();
    },

    bindCustomEvents: function(searchModel) {
        searchModel.on('submit', Odigeo._.bind(this.onSearchSubmit, this));
    },

    onSearchSubmit: function() {
        this.set('searchSubmit', this.getOriginalData().searchSubmit);
    },

    isOneWay: function() {
        return false;
    },
}));
